var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 17.75V15.9167C15.3334 14.9442 14.9471 14.0116 14.2595 13.3239C13.5718 12.6363 12.6392 12.25 11.6667 12.25H4.33341C3.36095 12.25 2.42832 12.6363 1.74069 13.3239C1.05306 14.0116 0.666748 14.9442 0.666748 15.9167V17.75",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 8.58333C10.0252 8.58333 11.6668 6.94171 11.6668 4.91667C11.6668 2.89162 10.0252 1.25 8.00016 1.25C5.97512 1.25 4.3335 2.89162 4.3335 4.91667C4.3335 6.94171 5.97512 8.58333 8.00016 8.58333Z",
    stroke: "#193566",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customers_icon.f2a77c508d9a99067b076276d62626fe.svg";
export { ForwardRef as ReactComponent };